import styled from "styled-components";
import { LEGEND_EFFIS_VALUES } from "../../constants/legends";

export default function GradientLegend() {
  return (
    <LegendContainer>
      <div className="legend-gradient"></div>
      <div className="legend-values">
        {LEGEND_EFFIS_VALUES.map((val, idx) => (
          <span key={idx}>{val}</span>
        ))}
      </div>
    </LegendContainer>
  );
}

const LegendContainer = styled.div`
  display: grid;
  margin-left: 26px;

  .legend-gradient {
    height: 13px;
    border-radius: 4px;
    background: linear-gradient(to right, #000004, #410967, #922666, #da5138, #faa40c, #f6f896);
  }

  .legend-values {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 700;
    padding: 0 2px;
  }
`;
